/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Type representing an employee workspace type
 */
export enum EmployeeWorkspaceType {
    FUNNEL_STATUS = 'funnel-status',
}
